import { useState } from "react";
import { ArrowRight } from "lucide-react";
import "./Test.css";
import home_icon_1 from "../../assets/images/home_icon_1.png";
import home_icon_2 from "../../assets/images/home_icon_2.png";
import home_icon_3 from "../../assets/images/home_icon_3.png";
import home_icon_4 from "../../assets/images/home_icon_4.png";
import home_icon_5 from "../../assets/images/home_icon_5.png";
import home_icon_6 from "../../assets/images/home_icon_6.png";
import home_hover_icon_1 from "../../assets/images/home_hover_icon_1.png";
import home_hover_icon_2 from "../../assets/images/home_hover_icon_2.png";
import home_hover_icon_3 from "../../assets/images/home_hover_icon_3.png";
import home_hover_icon_4 from "../../assets/images/home_hover_icon_4.png";
import home_hover_icon_5 from "../../assets/images/home_hover_icon_5.png";
import home_hover_icon_6 from "../../assets/images/home_hover_icon_6.png";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

const services = [
  {
    icon: home_icon_1,
    hover_icon: home_hover_icon_1,
    text: "AI Banking",
    path: "/gen-ai-banking",
    para: "Modernize banking with GenAI and cloud-native architectures. Enhance security, scalability, and cost efficiency while eliminating legacy constraints.",
  },
  {
    icon: home_icon_2,
    hover_icon: home_hover_icon_2,
    text: "Enterprise AI",
    path: "/enterprise-ai",
    para: "Move beyond automation—enable intelligent decisions, optimize processes, and personalize at scale. Seamlessly integrate AI to unlock insights, scale agents, and drive measurable growth.",
  },
  {
    icon: home_icon_3,
    hover_icon: home_hover_icon_3,
    text: "Data & Analytics",
    path: "/data-analytics",
    para: "Unify data, enhance quality, and deploy AI-driven analytics for real-time insights. Leverage cloud-native architectures to process data, optimize workflows, and drive automation for smarter decisions.",
  },
  {
    icon: home_icon_4,
    hover_icon: home_hover_icon_4,
    text: "Next-Gen Modernization",
    path: "/next-gen-modernization",
    para: "Leverage AI-driven automation, cloud-native architectures, and intelligent data ecosystems. Enable seamless integration, predictive analytics, and adaptive security to set new industry benchmarks.",
  },
  {
    icon: home_icon_5,
    hover_icon: home_hover_icon_5,
    text: "Cloud Innovations",
    path: "/cloud-innovations",
    para: "Drive resilience, scalability, and efficiency with a strategic cloud transformation. Leverage AWS, Azure, or Google Cloud Platform with a structured adoption approach.",
  },
  {
    icon: home_icon_6,
    hover_icon: home_hover_icon_6,
    text: "Managed Cybersecurity",
    path: "/managed-cybersecurity",
    para: "Defend against evolving cyber threats with AI-powered security frameworks that detect anomalies and predict attacks at every layer. Implement SOC2, ISO 27000, and NIST SP 800-53 frameworks to fortify security. ",
  },
];

export default function ServiceSlider() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="service-slider" style={{ backgroundColor: "#ebf0ff" }}> 
    <Container>
      <div className="service-slider-container">
        {/* <motion.div
          className="Productright text-center"
          initial={{ opacity: 1, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        > */}
          <h1 className="centered-title mb-3 section-title">
            Precision-Built Solutions
          </h1>

          <div className="service-slider-wrapper">
            {services.map((service, i) => (
              <div
                key={i}
                className="service-slider-item col-xl-3  col-md-2 col-sm-12"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Link to={service.path}>
                  <img
                    src={hoveredIndex === i ? service.hover_icon : service.icon}
                    className="service-slider-icon"
                    alt={service.text}
                  />
                  <h3 className="service-slider-title">{service.text}</h3>
                  <p className="fs-6 pb-3">
                    {service.para.length > 200
                      ? service.para.slice(0, 210) + ""
                      : service.para}
                  </p>
                  <div className="service-slider-arrow custom-arrow">
                    <span
                      className="arrow-text"
                      style={{ color: "white", marginRight: "10px" }}
                    >
                      Explore
                    </span>
                    <div className="arrow-line"></div>
                    <ArrowRight size={30} />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        {/* </motion.div> */}
      </div>
    </Container>
    </div>
  );
}
